export default __webpack_public_path__ + "assets/try.849c0d0281f9764111673500fd4e3c55.png";